import { createAction } from 'redux-api-middleware'
import qs from 'query-string'

import { HUBBLE_API_TOKEN } from '../../store/middleware/APIUrl'
import { DateUtils } from '../../utils'

const Types = {
    DASHBOARD_FETCH_STORE: {
        request: 'DASHBOARD_FETCH_STORE##REQUEST',
        success: 'DASHBOARD_FETCH_STORE##SUCCESS',
        failure: 'DASHBOARD_FETCH_STORE##FAILURE',
    },
}

function buildUrl(endpoint, from, to, query = {}) {
    return qs.stringifyUrl(
        {
            url: `${HUBBLE_API_TOKEN}/dashboard/${endpoint}`,
            query: {
                ...query,
                from: DateUtils.timestampSeconds(from),
                to: DateUtils.timestampSeconds(to),
            },
        },
        {
            skipNull: true,
        }
    )
}

function fetchStore(storeCode) {
    return createAction({
        endpoint: `${HUBBLE_API_TOKEN}/stores/${storeCode}`,
        method: 'GET',
        types: [Types.DASHBOARD_FETCH_STORE.request, Types.DASHBOARD_FETCH_STORE.success, Types.DASHBOARD_FETCH_STORE.failure],
    })
}

export { Types, buildUrl, fetchStore }
